import { v4 as uuid } from "uuid";
import Ajv from "ajv";
import ShoppingCartItem from "./ShoppingCartItem.schema.json";

const ajv = new Ajv();

const validateShoppingCartItem = ajv.compile(ShoppingCartItem);

export default () => {
	const getCart = () => {
		if (import.meta.client) {
			const fromLocalStorage = JSON.parse(localStorage.getItem("cart"));

			if (fromLocalStorage) return fromLocalStorage;

			localStorage.setItem("cart", JSON.stringify([])); // Make sure this check is not done again
			return [];
		} else {
			return [];
		}
	};

	const putCart = (cart) => {
		if (import.meta.client) {
			localStorage.setItem("cart", JSON.stringify(cart));
		}
	};

	const getCartContent = getCart;

	const addItem = (item) => {
		item = JSON.parse(JSON.stringify(item));
		const valid = validateShoppingCartItem(item);

		if (!valid) throw new Error(validateShoppingCartItem.errors);

		const cart = getCart();

		if (item.id) {
			const existing = cart.findIndex((i) => i.id === item.id);
			if (existing > -1) cart[existing] = item;
			else cart.push(item);
		} else {
			item.id = uuid();
			cart.push(item);
		}

		putCart(cart);

		return cart;
	};

	const removeItem = (itemId) => {
		let cart = getCart();

		const itemIndex = cart.findIndex((item) => item.id === itemId);

		if (itemIndex < 0) throw new Error(`Item not found: ${itemId}`);

		cart.splice(itemIndex, 1);

		putCart(cart);

		return cart;
	};

	const emptyCart = () => {
		putCart([]);

		return [];
	};

	return {
		getCartContent,
		removeItem,
		addItem,
		emptyCart,
	};
};
